export interface TrackItem {
  time: string;
  tag: string;
  tone: "out" | "verify" | "lock" | "hot";
  title: string;
  brief: string;
}

// 首屏主推：新近曝光导语下的重点条目
export const leadItems: TrackItem[] = [
  {
    time: "09:41",
    tag: "实锤",
    tone: "lock",
    title: "连锁餐企「现煮」宣传被扒后厨用预包装",
    brief: "菜单宣传与后厨影像逐帧比对完成，多处口径对不上，结论已落定归档。",
  },
  {
    time: "02:18",
    tag: "存疑",
    tone: "verify",
    title: "电竞转会费虚报截图流传，关键页缺时间戳",
    brief: "截图缺失可校验元数据，交易细节与经纪方回应仍在交叉核对。",
  },
  {
    time: "昨日 23:07",
    tag: "流出",
    tone: "out",
    title: "待播剧改档内部邮件流出，档期调整引热议",
    brief: "邮件措辞与招商排期吻合度高，档期变动或波及后续排片节奏。",
  },
];

// 持续追踪 · 新近事件推进时间轴
export const trackLine: TrackItem[] = [
  {
    time: "今天 09:41",
    tag: "实锤",
    tone: "lock",
    title: "某连锁餐企「现煮」宣传名不副实",
    brief: "后厨改用预包装影像与菜单口径比对完成，宣传用语涉嫌夸大，结论已归档。",
  },
  {
    time: "今天 02:18",
    tag: "存疑",
    tone: "verify",
    title: "电竞转会费报价截图待验真",
    brief: "截图关键页缺时间戳与源链接，已联络经纪方补充对账口径。",
  },
  {
    time: "昨天 23:07",
    tag: "流出",
    tone: "out",
    title: "待播剧改档内部邮件流出",
    brief: "邮件内部措辞与招商排期高度吻合，改档传言可信度上升。",
  },
  {
    time: "昨天 18:55",
    tag: "曝光",
    tone: "out",
    title: "理财主播收益图疑被 P 图",
    brief: "收益截图图像元数据异常，正在回溯历史直播间的同款界面。",
  },
  {
    time: "前天 15:22",
    tag: "追踪",
    tone: "hot",
    title: "母婴品牌抽检新闻被反向带节奏",
    brief: "完整抽检通报整理完毕，正向解读与断章取义的差异点已逐条标注。",
  },
];

// 话题墙 · 热词话题
export const topicWall: string[] = [
  "餐饮现煮造假",
  "主播收益真伪",
  "转会费虚报",
  "待播剧改档",
  "综艺经费夸大",
  "网红品牌代工",
  "机构退款维权",
  "专辑旋律撞车",
  "录制现场物料",
  "合同纠纷录音",
  "综艺剪辑争议",
  "代言解约内幕",
  "演唱会发生意外",
  "售后承诺翻车",
  "团队口径反复",
  "饭圈互撕实录",
];

// 新瓜速览 · 近期流出重点条目（标题优先、配图克制）
export interface ExposeItem {
  index: string;
  hot: number;
  title: string;
  meta: string;
  summary: string;
  flag: "新" | "热" | "持续";
}

export const exposeItems: ExposeItem[] = [
  {
    index: "E-01",
    hot: 98,
    title: "某头部直播机构分红比例录音流出",
    meta: "流出 2h · 音频 47s",
    summary: "录音中涉及的分红口径与年报披露不一致，待核对完整版本。",
    flag: "热",
  },
  {
    index: "E-02",
    hot: 91,
    title: "连锁餐企「现煮」后厨现预包装",
    meta: "实锤 5h · 影像对比",
    summary: "宣传语与后厨实际流程存明显出入，结论已整理归档。",
    flag: "新",
  },
  {
    index: "E-03",
    hot: 84,
    title: "偶像厂牌选人内幕群聊被外传",
    meta: "流出 8h · 群聊截图",
    summary: "群聊角色权限未经实名，是否本人发言仍在核实中。",
    flag: "持续",
  },
  {
    index: "E-04",
    hot: 77,
    title: "综艺道具经费报销明细外泄",
    meta: "曝光 11h · 明细单",
    summary: "明细单价与市价差距明显，财务口径尚未回应。",
    flag: "新",
  },
  {
    index: "E-05",
    hot: 70,
    title: "网红代餐被曝更换代工厂原料",
    meta: "流出 14h · 采购单",
    summary: "采购单供应商代号与宣传产地不同，追溯链条待补齐。",
    flag: "热",
  },
  {
    index: "E-06",
    hot: 63,
    title: "线下培训机构退款条款被指玩文字游戏",
    meta: "持续 1d · 学员群聊",
    summary: "多名学员截图口径一致，退款比例与条款表述存冲突。",
    flag: "持续",
  },
];

// 求证 · 流出信息核对
export interface VerifyItem {
  title: string;
  status: "待核" | "存疑" | "已证";
  progress: string;
  note: string;
}

export const verifyItems: VerifyItem[] = [
  {
    title: "「退出演艺圈」声明是否为本人账号发出",
    status: "待核",
    progress: "进行中",
    note: "账号登录地记录待官方配合调取",
  },
  {
    title: "综艺所谓「临时改剧本」剪辑版本比对",
    status: "存疑",
    progress: "对账中",
    note: "前后镜头衔接存在两处断点，暂无法定论",
  },
  {
    title: "主播收益截图元数据分析",
    status: "已证",
    progress: "已结论",
    note: "多处印章与字体与官方模板不一致，判定高概率为合成",
  },
  {
    title: "明星团队合同违约金数额是否被夸大",
    status: "存疑",
    progress: "对账中",
    note: "流出页缺失签署页与日期，真实性有限",
  },
];

// 专题合集 · 把散料串成专题
export interface Series {
  name: string;
  desc: string;
  count: string;
  tone: "primary" | "gold" | "paper";
  reads: string;
}

export const seriesList: Series[] = [
  {
    name: "主播收益真伪档案",
    desc: "收益截图、直播间回放与平台规则逐条对照，一探水分到底有多大。",
    count: "12 则",
    tone: "primary",
    reads: "38.6w 阅读",
  },
  {
    name: "网红产品翻车记",
    desc: "代工工厂、原料采购、宣传口径，把「爆款」从立项到售后的坑都摊开讲。",
    count: "9 则",
    tone: "gold",
    reads: "27.1w 阅读",
  },
  {
    name: "餐饮「现制」真相",
    desc: "后厨影像、中央厨房与门店菜单三方对拍，还原一张菜单背后的真实流程。",
    count: "7 则",
    tone: "primary",
    reads: "19.8w 阅读",
  },
  {
    name: "影视改档风波",
    desc: "内部邮件、招商排期与平台回应交叉还原，一档节目改期背后谁在博弈。",
    count: "11 则",
    tone: "paper",
    reads: "22.4w 阅读",
  },
  {
    name: "机构退款维权实录",
    desc: "协议条款、聊天记录与消保口径合集，为还在拉锯的消费者提供对照样本。",
    count: "8 则",
    tone: "gold",
    reads: "15.3w 阅读",
  },
  {
    name: "饭圈互撕复盘",
    desc: "从起因到发酵逐帧梳理，不站队、只还原事件本身的是非来龙去脉。",
    count: "10 则",
    tone: "paper",
    reads: "33.9w 阅读",
  },
];

// 持续追踪 live 短讯
export const liveNotes: string[] = [
  "正在核验：某头部主播分红比例录音的完整版本",
  "新增存档：餐企「现煮」宣传用语比对 3 处冲突点",
  "追踪升温：待播剧改档消息带动同档期排片讨论",
  "收到线报：某厂牌内部薪酬截图待解密，谨慎对待",
];